import api from "@/lib/api";

// Starts a background generation job and polls until done/error.
export async function runGeneration(kind, payload, { onTick } = {}) {
  const { data } = await api.post("/jobs", { kind, payload });
  const id = data.id;
  return new Promise((resolve, reject) => {
    let elapsed = 0;
    const timer = setInterval(async () => {
      elapsed += 2.5;
      onTick && onTick(elapsed);
      if (elapsed > 180) {
        clearInterval(timer);
        reject(new Error("This is taking longer than expected. Please try again."));
        return;
      }
      try {
        const { data: j } = await api.get(`/jobs/${id}`);
        if (j.status === "done") { clearInterval(timer); resolve(j); }
        else if (j.status === "error") { clearInterval(timer); reject(new Error(j.error || "Generation failed")); }
      } catch (e) {
        clearInterval(timer); reject(e);
      }
    }, 2500);
  });
}
